import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

const defaultDeliverables = [
    {
        id: 1,
        title: "Platform Foundation",
        desc: "Workspace and environment design for development, testing, and production, aligned with your cloud setup.",
    },
    {
        id: 2,
        title: "Security and Networking",
        desc: "Workspace and environment design for development, testing, and production, aligned with your cloud setup.",
    },
    {
        id: 3,
        title: "Platform Foundation",
        desc: "Workspace and environment design for development, testing, and production, aligned with your cloud setup.",
    },
    {
        id: 4,
        title: "Governance & Unity Catalog",
        desc: "Workspace and environment design for development, testing, and production, aligned with your cloud setup.",
    },
];

export const TechServicesSection = ({
    badge = "Implementation scope",
    heading = "What we deliver",
    description = "The right platform components for your current priorities, with security, governance, deployment, and cost controls considered as part of the same implementation.",
    deliverables = defaultDeliverables,
}) => {
    const [sliderRef, instanceRef] = useKeenSlider(
        {
            loop: true,
            slides: {
                perView: 1.15,
                spacing: 20,
            },
            breakpoints: {
                "(min-width: 640px)": {
                    slides: { perView: 2.1, spacing: 20 },
                },
                "(min-width: 1024px)": {
                    slides: { perView: 2.5, spacing: 20 },
                },
            },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;
                function clearNextTimeout() {
                    clearTimeout(timeout);
                }
                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }
                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseout", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("dragStarted", clearNextTimeout);
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="w-full bg-white pb-[60px] lg:pb-[100px] lg:pt-[50px] pt-[20px]">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 lg:mb-[40px] mb-[20px]">
                    <div>
                        <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora leading-[1.18]">
                            {heading}
                        </h2>
                    </div>
                    {/* <p className="text-[#01386A] font-graphik text-[14px] md:text-[16px] font-[500] max-w-[700px] leading-[1.65]">
                        {description}
                    </p> */}
                </div>

                <div ref={sliderRef} className="keen-slider">
                    {deliverables.map((item) => (
                        <div
                            key={item.id || item.title}
                            className="keen-slider__slide"
                        >
                            <div className="h-[280px] sm:h-[300px] border border-[#BAC9D7] p-[20px] sm:p-[40px] flex flex-col justify-between bg-white">
                                <div>
                                    <h3 className="text-[#01386A] text-[16px] sm:text-[20px] font-[600] font-sora leading-[1.25] mb-4">
                                        {item.title}
                                    </h3>
                                    <div className="w-[42px] h-[2.5px] bg-[#ED6800]" />
                                </div>

                                <p className="text-[#01386A] font-graphik text-[14px] md:text-[16px] font-[500] leading-[1.6]">
                                    {item.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex items-center gap-3 mt-8">
                    <button
                        onClick={() => instanceRef.current?.prev()}
                        className="w-8 h-8 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center transition-colors duration-200 hover:bg-[#ED6800] hover:text-white"
                        aria-label="Previous slide"
                    >
                        <svg
                            className="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                            />
                        </svg>
                    </button>
                    <button
                        onClick={() => instanceRef.current?.next()}
                        className="w-8 h-8 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center transition-colors duration-200 hover:bg-[#ED6800] hover:text-white"
                        aria-label="Next slide"
                    >
                        <svg
                            className="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default TechServicesSection;